import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { createMerchant, updateMerchant, getAllMerchants } from "./MerchantService";

export default function MerchantForm(){
  const [merchantName,setMerchantName]=useState("");
  const [merchantType,setMerchantType]=useState("SHOP");
  const [active,setActive]=useState(true);

  const {id}=useParams();
  const nav=useNavigate();

  useEffect(()=>{
    if(id) load();
  },[id]);

  const load = async ()=>{
    const all = await getAllMerchants();
    const m = all.find(x=>x.id===id);
    if(m){
      setMerchantName(m.merchantName);
      setMerchantType(m.merchantType);
      setActive(m.active);
    }
  };

  const submit = async (e)=>{
    e.preventDefault();

    if(id){
      await updateMerchant(id, merchantName, merchantType, active);
    }else{
      await createMerchant(merchantName, merchantType);
    }

    nav("/expense/merchants");
  };

  return (
    <form onSubmit={submit}>
      <h3>{id ? "Edit Merchant":"Add Merchant"}</h3>

      <input 
        value={merchantName}
        onChange={e=>setMerchantName(e.target.value)}
        placeholder="Merchant Name"
        required
      />

      <select value={merchantType} onChange={e=>setMerchantType(e.target.value)}>
        <option value="SHOP">SHOP</option>
        <option value="ONLINE">ONLINE</option>
        <option value="SERVICE">SERVICE</option>
        <option value="BANK">BANK</option>
        <option value="PERSON">PERSON</option>
      </select>

      <label>
        Active:
        <input type="checkbox" checked={active} onChange={e=>setActive(e.target.checked)} />
      </label>

      <br/><br/>
      <button type="submit">Save</button>
    </form>
  );
}
